(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
var util = require('widgets-util');
var loadJS = require('./load-script');
var loadCSS = require('./load-css');
var async = require('./async');
var Api = require('./api');

var InGo = window.InGo = window.InGo || {};
var defaultOptions = { baseUrl: "https://ingo.me", version: '0.9.0' };

function runWidget(container, config, options)
{
    var opts = util.deepExtend({}, config.params, options);
    if (opts.debug && window.console) ;
    var methodName = config.type + 'Widget';
    if (InGo.$ && InGo.$.fn && InGo.$.fn[methodName]) {
        InGo.$(container)[methodName](opts);
    } else
    if (InGo[methodName]) {
        InGo[methodName](opts);
    } else {
        throw new Error('InGo: Unable to find ' + methodName);
    }
    if (typeof options.onLoad == "function") options.onLoad(config);
}

function loadWidget(el, config, options)
{
    if (options.debug && window.console) ;
    if (!InGo._widgets) InGo._widgets = {};
    if (!InGo._widgets[config.type + '-' + config.version]) {
        async.each(getAbsoluteUrls(config.css, config, options), loadCSS);
        async.eachOrdered(getAbsoluteUrls(config.js, config, options), loadJS, function() {
            InGo._widgets[config.type + '-' + config.version] = config.params;
            loadCustom(config.params);
            runWidget(el, config, options);
        });
    } else {
        InGo._widgets[config.type + '-' + config.version] = config.params;
        loadCustom(config.params);
        runWidget(el, config, options);
    }
}

// Inject inline styles and code
function loadCustom(config)
{
    if (config && typeof config.css_data == "string" && util.trim(config.css_data).match(/^<style/)) InGo.$(config.css_data).appendTo(document.head);
    if (config && typeof config.js_data == "string" && util.trim(config.js_data).match(/^<script/)) InGo.$(config.js_data).appendTo(document.head);
}

function ingoWidget(options)
{
    var self = this;
    options = util.deepExtend({}, defaultOptions, options);
    var api = new Api(options);
    if (options.debug && window.console) ;
    api.config({}, function(config) {
        if (config.useJQuery) {
            checkJQuery(options, function() {
                loadWidget(self, config, options);
            });
        } else {
            loadWidget(self, config, options);
        }
    });
    return this;
}

// Make sure all urls in the list are absolute, in same origin mode use the loader path for
// js/css files, they can be in the same or different folders(/js/, /css/)
function getAbsoluteUrls(list, config, options)
{
    var rx = /^(https?:\/\/|\/\/)/i, urls = [];
    if (!list || !list.length) return [];
    for (var i = 0; i < list.length; i++) {
        var url = typeof list[i] == "string" ? list[i] : "";
        if (!url) continue;
        if (options.sameOrigin && options.href && url.match("ingo." + config.type + ".widget")) {
            var file = url.split("/").pop();
            if (file.match(/\.css$/i) && options.href.match(/\/js\//i)) file = "../css/" + file;
            url = options.href + file;
        } else
        if (!list[i].match(rx)) {
            url = (options.host || "") + list[i];
        }
        urls.push(url);
    }
    if (options.debug && window.console) ;
    return urls;
}

function toCamel(name)
{
    return String(name || "").replace(/(?:[\-\_\.])(\w)/g, function (_, c) { return c ? c.toUpperCase () : ''; });
}

// Update or create new object with the given property, name can be a simple property name or a path of properties separated by dots,
// in such case all required intermediate object containers will be crated automatically.
function setProp(obj, name, value)
{
    
    if (!obj) obj = {};
    if (!name) return obj;
    name = name.split(".");
    var v = obj, n;
    for (var i = 0; i < name.length - 1; i++) {
        n = toCamel(name[i]);
        if (typeof obj[n] == "undefined") obj[n] = {};
        obj = obj[n];
    }
    n = toCamel(name[name.length - 1]);
    obj[n] = value == "true" ? true : value == "false" ? false : value.match(/^[0-9]+$/) ? parseInt(value, 10) : value.match(/^[0-9]+\.[0-9]+$/) ? parseFloat(value, 10) : value;
    return v;
}

// Load jQuery if needed and then call the callback, use InGo.$ instead of global jQuery from now on
function checkJQuery(options, callback)
{
    if (!InGo.$) InGo.$ = window.jQuery;
    if (InGo.$) {
        var ver = (InGo.$.fn ? InGo.$.fn.jquery : "0.0").split(".");
        if (options.debug && window.console) ;
        for (var i = 0; i < ver.length; i++) ver[i] = parseInt(ver[i], 10);
        if (!ver[0] || !ver[1] || (ver[0] <= 1 && ver[1] < 7)) InGo.$ = null;
    }
    if (InGo.$) {
        InGo.$.fn.ingoWidget = InGo.$.fn.loaderWidget = ingoWidget;
        return callback();
    }
    if (options.debug && window.console) ;
    loadJS((options.href || "/js/") + "jquery.js", function(err) {
        if (err) throw err;
        if (!InGo.$) InGo.$ = jQuery.noConflict(true);
        InGo.$.fn.ingoWidget = InGo.$.fn.loaderWidget = ingoWidget;
        callback();
    });
}

// Return first not yet used <script> tag for our file
function getTag()
{
    if (!InGo._jstags) InGo._jstags = [];
    var rx = /\/ingo\.loader\.widget\.js/i;
    var tags = document.getElementsByTagName('script');
    for (var i = 0; i < tags.length; i++) {
        var tag = tags[i];
        if (!tag.parentNode || !tag.src.match(rx)) continue;
        for (var j = 0; tag && j < InGo._jstags.length; j++) if (InGo._jstags[j] == tag) tag = null;
        if (!tag) continue;
        InGo._jstags.push(tag);
        return tag;
    }
    return null;
}

// Parse tag atrributes, set defaults, returns an object with attributes
function parseTag(tag)
{
    if (!tag) return {};
    // Collect all attributes passed in the script tag
    var options = {};
    for (var i in tag.attributes) {
        var name = tag.attributes[i].name;
        if (name && name.substr(0, 10) == "data-ingo-") setProp(options, name.substr(10), tag.attributes[i].value);
    }

    // Replace the base url for other widgets with the origin host, it is always absolute even if we are testing it locally
    var d = tag.src.match(/^(https?:\/\/|\/\/)/i);
    if (d) {
        options.href = tag.src.split("/").slice(0, -1).join("/") + "/";
        options.host = "//" + tag.src.replace(d[1], "").split("/")[0];
    }
    // In the same origin mode take all files from the same server
    if (options.sameOrigin || defaultOptions.sameOrigin) options.baseUrl = options.host;

    // Try to determine page language/locale
    if (!options.lang) {
        var html = document.querySelector("html");
        if (html && html.lang) options.langId = html.lang;
        if (!options.langId) {
            var meta = document.querySelector("meta[name=lang], meta[name=language], meta[itemprop=lang], meta[itemprop=language]");
            if (meta && meta.content) options.langId = meta.content;
        }
    }

    // Set widget type if no id is given or use default type, support widget type in the form of data-ingo-login, data-ingo-social
    if (!options.type && !options.id) {
        util.forEach(["login","social","registration","confirmation"], function(x) {
            if (!options.type && typeof options[x] != "undefined") options.type = x;
        });
    }
    if (options.debug && window.console) ;
    return options;
}

// Given a script tag with properties, try to instantiate a widget in place
function runTag(tag, options)
{
    if (!tag) return;
    if (!options) options = defaultOptions;
    // Only instantiate if we have id or type, otherwise just keep it loaded to be used directly from scripts
    if (!options.id && !options.type) return;
    // Inject in place and bind to optional target or anonymous div
    var div = options.target ? document.querySelector(options.target) : null;
    if (!div) {
        if (options.button) {
            div = document.createElement("button");
            div.appendChild(document.createTextNode(options.button));
        } else {
            div = document.createElement("div");
        }
    }
    tag.parentNode.insertBefore(div, tag);
    ingoWidget.call(div, options);
}

// Global widget reference
InGo.ingoWidget = InGo.loaderWidget = ingoWidget;
// To be able to launch widgets from the global jQuery selector
if (window.jQuery) window.jQuery.fn.ingoWidget = window.jQuery.fn.loaderWidget = ingoWidget;

// Extract tag attributes so we can use base url for loading other scripts
var tag = getTag();
runTag(tag, parseTag(tag));


},{"./api":2,"./async":3,"./load-css":4,"./load-script":5,"widgets-util":10}],2:[function(require,module,exports){
var Transport = require('widgets-transport')();
var util = require('widgets-util');

var API = function(options) {
  this.options = options;
  this.transport = new Transport({ baseUrl: this.options.baseUrl });
};

API.prototype = {
    config: function(params, success) {
        params.widget_unique_id = this.options.id || this.options.widgetId || "";
        params.event_id = this.options.eventId || this.options.ingoId || "";
        params.widget_type = this.options.type || this.options.widget_type || this.options.widgetType || "";
        params.url = this.options.url || window.location.href || "";
        params.lang = this.options.lang || this.options.langId || "" ;
        params.version = this.options.version || "" ;
        var qs = util.queryString(params);
        this.transport.send({ url: (this.options.baseUrl || this.options.host || "") + '/api/v1/widget/config' + (qs ? '?' + qs : '') }, function(err, res) {
            if (err) throw err;
            success(JSON.parse(res));
        });
    }
};

module.exports = API;

},{"widgets-transport":8,"widgets-util":10}],3:[function(require,module,exports){
var util = require('widgets-util');

function asyncEach(arr, func, callback) {
  var loaded = arr.length;
  util.forEach(arr, function(el) {
    func(el, function() {
      loaded--;

      if(loaded == 0 && callback) callback();
    });
  })
}

function asyncEachOrdered(arr, func, callback) {
  if(arr.length > 0) {
    var first = arr.shift();
    func(first, function() {
      asyncEachOrdered(arr, func, callback);
    })
  } else {
    callback();
  }
}

module.exports.each = asyncEach;

module.exports.eachOrdered = asyncEachOrdered;
},{"widgets-util":10}],4:[function(require,module,exports){
/*!
 loadCSS: load a CSS file asynchronously.
 [c]2014 @scottjehl, Filament Group, Inc.
 Licensed MIT
 */
function loadCSS(href) {
  "use strict";
  // Arguments explained:
  // `href` is the URL for your CSS file.
  // `before` optionally defines the element we'll use as a reference for injecting our <link>
  // By default, `before` uses the first <script> element in the page.
  // However, since the order in which stylesheets are referenced matters, you might need a more specific location in your document.
  // If so, pass a different reference element to the `before` argument and it'll insert before that instead
  // note: `insertBefore` is used instead of `appendChild`, for safety re: http://www.paulirish.com/2011/surefire-dom-element-insertion/
  var ss = window.document.createElement("link");
  var ref = window.document.getElementsByTagName("head")[ 0 ];
  ss.rel = "stylesheet";
  ss.href = href;
  // temporarily, set media to something non-matching to ensure it'll fetch without blocking render
  ss.media = "only x";
  // inject link
  ref.appendChild(ss);
  // set media back to `all` so that the styleshet applies once it loads
  setTimeout(function() {
    ss.media = "all";
  }, 0);
}

module.exports = loadCSS;
},{}],5:[function(require,module,exports){
module.exports = function load(src, cb) {
  var head = document.head || document.getElementsByTagName('head')[0];
  var script = document.createElement('script');

  cb = cb || function() {
  };

  script.type = 'text/javascript';
  script.charset = 'utf8';
  script.async = true;
  script.src = src;

  var onend = 'onload' in script ? stdOnEnd : ieOnEnd;
  onend(script, cb);

  // some good legacy browsers (firefox) fail the 'in' detection above
  // so as a fallback we always set onload
  // old IE will ignore this and new IE will set onload
  if(!script.onload) {
    stdOnEnd(script, cb);
  }

  head.appendChild(script)
};

function stdOnEnd(script, cb) {
  script.onload = function() {
    this.onerror = this.onload = null;
    cb()
  };
  script.onerror = function() {
    // this.onload = null here is necessary
    // because even IE9 works not like others
    this.onerror = this.onload = null;
    cb(new Error('Failed to load ' + this.src))
  }
}

function ieOnEnd(script, cb) {
  script.onreadystatechange = function() {
    if(this.readyState != 'complete' && this.readyState != 'loaded') return;
    this.onreadystatechange = null;
    cb(null, true); // there is no way to catch loading errors in IE8
  }
}

},{}],6:[function(require,module,exports){

var Transport;
module.exports = Transport = function Transport(options) {
    this.options = options;
}

Transport.supported = function() {
    return true;
};

Transport.prototype = {
    constructor: Transport,

    send: function(params, callback) {
        throw new Error('Each transport should implement .send');
    }
}
},{}],7:[function(require,module,exports){
var Transport = require('./base');
var util = require('widgets-util');

var channelPath = '/ajax-channel/v1';

var domain = document.domain;

function uid () {
    return domain + '-' + (1*new Date()) + '-' + (Math.random()*1000).toFixed();
}

function addEventListener(el, event, callback) {
    if (!el.addEventListener)
        el.attachEvent("on" + event, callback);
    else
        el.addEventListener(event, callback, false);
}

var IFramePostMessage;
module.exports = IFramePostMessage = function IFramePostMessage(options) {
    options = options || {};
    options.channelUrl = options.baseUrl + (options.channelPath || channelPath);

    Transport.call(this, options);

    var that = this;

    this.frame = document.createElement("iframe");
    this.frame.style.display = 'none';
    this.frame.style.visibility = 'hidden';


    this.messageQueue = {};
    this.preLoadQueue = [];

    this.loaded = false;

    addEventListener(this.frame, 'load', function() {
      that.loaded = true;

      while(that.preLoadQueue.length) {
        var data = that.preLoadQueue.shift();
        that.send(data.options, data.callback);
      }
    });

    // set src after onload callback not before!!!
    this.frame.src = this.options.channelUrl;

    addEventListener(window, 'message', function(e) {
        if (e.origin.indexOf(that.options.baseUrl) !== 0)
            return;

        var data = JSON.parse(e.data);
        var requestData = that.messageQueue[data.inGoRequestId];
        if(requestData) {
            var error = null;
            if('error' in data) {
                error = new Error(data.error);
                error.status = data.status;
            }
            requestData.callback(error, data.data);
            delete that.messageQueue[data.inGoRequestId];
        }
    });

    //XXX add a check that dom loaded and in other case wait for DOM ready
    //this will break in case of script in head
    document.body.appendChild(this.frame);
};

IFramePostMessage.supported = function() {
    return 'postMessage' in window;
};

util.inherits(IFramePostMessage, Transport);
IFramePostMessage.prototype.constructor = IFramePostMessage;

IFramePostMessage.prototype.send = function(options, callback) {
    if(this.loaded) {
        var id = uid();
        options.inGoRequestId = id;
        this.messageQueue[id] = { id: id, options: options, callback: callback };
        this.frame.contentWindow.postMessage(JSON.stringify(options), this.options.baseUrl); //IE8 and IE9 need that target will be iframe domain (for mystic security reasons)
    } else {
        this.preLoadQueue.push({ options: options, callback: callback });
    }
};
},{"./base":6,"widgets-util":10}],8:[function(require,module,exports){
var xhr = require('./xhr');
var iframe = require('./iframe');

var transports = [iframe, xhr];

function bestTransport() {
	var i = transports.length;
    while(i-- && !transports[i].supported());
    return transports[i];
}

module.exports = bestTransport;

},{"./iframe":7,"./xhr":9}],9:[function(require,module,exports){
var Transport = require('./base');
var util = require('widgets-util');


function XhrError(message, status) {
  Error.call(this);

  this.name = 'XhrError';
  this.message = message;
  this.status = status;
}

util.inherits(XhrError, Error);

var XHR;
module.exports = XHR = function XHR(options) {
  Transport.call(this, options);
};

XHR.supported = function() {
  var xhr = new XMLHttpRequest();
  return 'withCredentials' in xhr;
};

util.inherits(XHR, Transport);

XHR.prototype.constructor = XHR;

XHR.prototype.send = function(options, callback) {
  var req = new XMLHttpRequest();

  if(Object.prototype.toString.call(options) == '[object String]') {
    options = { url: options };
  }

  req.open(options.method || 'GET', options.url, true);

  options.headers = options.headers || {};
  options.headers['X-Requested-With'] = 'XMLHttpRequest';

  req.withCredentials = true;

  util.forOwn(options.headers, function(value, key) {
    req.setRequestHeader(key, value);
  });

  req.onreadystatechange = function() {
    if(req.readyState != 4) return;

    if([
      200,
      304,
      0
    ].indexOf(req.status) === -1) {
      callback(new XhrError('Server responded with a status of ' + req.status, req.status));
    } else {
      callback(null, req.responseText);
    }
  };

  if(typeof console !== 'undefined' && console.log) {
    req.onerror = function() {
      console.log('We encountered an error attempting to fulfill the request. Please ensure that "' + location.protocol + '//' + location.host + '" is whitelisted in CORS list.');
    };
  }

  req.send(options.data || void 0);
};
},{"./base":6,"widgets-util":10}],10:[function(require,module,exports){
var hasOwnProperty = Object.prototype.hasOwnProperty;
function forOwn(obj, callback, context) {
  for(var prop in obj) {
    if(hasOwnProperty.call(obj, prop)) {
      var res = callback.call(context, obj[prop], prop, obj);
      if(res === false) return;
    }
  }
}

// taken from underscore, i am lazy to wrote tham myself

// Returns a function, that, when invoked, will only be triggered at most once
// during a given window of time. Normally, the throttled function will run
// as much as it can, without ever going more than once per `wait` duration;
// but if you'd like to disable the execution on the leading edge, pass
// `{leading: false}`. To disable execution on the trailing edge, ditto.
exports.throttle = function(func, wait, options) {
  var context, args, result;
  var timeout = null;
  var previous = 0;
  options || (options = {});
  var later = function() {
    previous = new Date;
    timeout = null;
    result = func.apply(context, args);
  };
  return function() {
    var now = new Date;
    if(!previous && options.leading === false) previous = now;
    var remaining = wait - (now - previous);
    context = this;
    args = arguments;
    if(remaining <= 0) {
      clearTimeout(timeout);
      timeout = null;
      previous = now;
      result = func.apply(context, args);
    } else if(!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };
};

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
exports.debounce = function(func, wait, immediate) {
  var result;
  var timeout = null;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      if(!immediate) result = func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if(callNow) result = func.apply(context, args);
    return result;
  };
};

exports.falsy = function falsy() {
  return false;
};

exports.queryString = function queryString(query) {
  var q = [];
  forOwn(query, function(value, key) {
    q.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
  });
  return q.join('&');
};

exports.noop = function() {
};

exports.forOwn = forOwn;

exports.deepExtend = function deepExtend(out, next) {
  out = out || (isArray(next) ? [] : {});

  for(var i = 1; i < arguments.length; i++) {
    var obj = arguments[i];

    if(!obj)
      continue;

    forOwn(obj, function(value, key) {
      out[key] = (typeof value === 'object') ? deepExtend(out[key], value) : value;
    });
  }

  return out;
};

var oCreate = Object.create || (function() {
    var F = function() {
    };
    return function(proto) {
      F.prototype = proto;
      var result = new F();
      F.prototype = null;
      return result;
    };
  })();

exports.inherits = function inherits(clazz, superClazz) {
  clazz.prototype = oCreate(superClazz.prototype);
};

var oToString = Object.prototype.toString;
exports.isArray = Array.isArray || isArray;
function isArray(arr) {
  return oToString.call(arr) == '[object Array]';
}

exports.forEach = exports.forOwn;

var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
var trimSupported = !!String.prototype.trim;

exports.trim = function(str) {
  return trimSupported ? str.trim() : str.replace(rtrim, '');
};

var indexOfSupported = !!Array.prototype.indexOf;

//like Array.prototype.indexOf but a bit more simple
exports.indexOf = function(arr, obj, startIndex) {
  if(indexOfSupported) return arr.indexOf(obj, startIndex);
  for(var i = startIndex || 0, l = arr.length; i < l; i++) {
    if(arr[i] === obj) return i;
  }
  return -1;
};

/**
 * Object.keys for ES3 support.
 * TODO: Maybe use https://github.com/cujojs/poly instead of writing these ourselves.
*/
exports.keys = function keys(obj) {
  obj = obj || {};
  var result = [];
  for (var key in obj) {
    if (hasOwnProperty.call(obj, key)) result.push(key);
  }
  return result;
};
},{}]},{},[1])

